import { makeResetStyles, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    MoneyCalculator20Filled, MoneyCalculator20Regular,
    ShiftsTeam20Filled, ShiftsTeam20Regular,
    //BuildingBank20Filled, BuildingBank20Regular,
    PeopleTeam20Filled, PeopleTeam20Regular,
    DocumentFolder20Filled, DocumentFolder20Regular,
    Info20Filled, Info20Regular,
    GlobeShield20Filled, GlobeShield20Regular,
    AppsListDetail20Filled, AppsListDetail20Regular,
    DocumentDatabase20Filled, DocumentDatabase20Regular,
    BoxSearch20Filled, BoxSearch20Regular,
    TaskListSquarePerson20Filled, TaskListSquarePerson20Regular,
    TaskListSquareDatabase20Filled, TaskListSquareDatabase20Regular,
    ContactCard20Filled, ContactCard20Regular,
    CardUi20Filled, CardUi20Regular,
    ContactCardRibbon20Filled, ContactCardRibbon20Regular,
    BoxCheckmark20Filled, BoxCheckmark20Regular,
    Box20Filled, Box20Regular,
    BoxArrowLeft20Filled, BoxArrowLeft20Regular,
    BoxArrowUp20Filled, BoxArrowUp20Regular,
    Timeline20Filled, Timeline20Regular,
    Board20Filled, Board20Regular,
    GlobeArrowForwardFilled, GlobeArrowForwardRegular,
    GlobeAddFilled, GlobeAddRegular,
    GlobeDesktopFilled, GlobeDesktopRegular,
    GlobeShieldFilled, GlobeShieldRegular,
    CodeBlockEditFilled, CodeBlockEditRegular,
    CodeBlockFilled, CodeBlockRegular,
    GlobeClockFilled, GlobeClockRegular,
    DeleteRegular, DeleteFilled,
    TextGrammarSettingsFilled, TextGrammarSettingsRegular,
    PlugConnectedSettingsFilled, PlugConnectedSettingsRegular,
    EditRegular, EditFilled,
    bundleIcon,
    PeopleCommunity24Filled, PeopleCommunity24Regular,
    Eye24Filled, Eye24Regular,
    ArrowUpload24Filled, ArrowUpload24Regular,
    ArrowDownload24Filled, ArrowDownload24Regular,
    BinRecycle24Filled, BinRecycle24Regular,
    FolderSync24Regular, FolderSync24Filled,
    Filter24Filled, Filter24Regular,
    Add24Filled, Add24Regular,
    ArrowClockwise24Filled, ArrowClockwise24Regular,
    InfoFilled, InfoRegular,
    BookStarFilled, BookStarRegular,
    DocumentOnePageAddFilled, DocumentOnePageAddRegular,
    MailArrowForwardFilled, MailArrowForwardRegular,
    CalendarPersonFilled, CalendarPersonRegular,
    DocumentPdfFilled, DocumentPdfRegular,
    TaskListLtrFilled, TaskListLtrRegular,
    CopySelectFilled,
    CopySelectRegular
} from "@fluentui/react-icons";

export const useEditorStyles = makeStyles({
    root: {
        // Stack the label above the field with a gap
        display: "grid",
        justifyItems: "start",
        ...shorthands.gap("20px"),
        maxWidth: "400px",
    },
    field70: {
        width: "70%",
        display: "grid",
        justifyItems: "start",
        ...shorthands.gap("5px"),
    },
    field20: {
        width: "20%",
        display: "grid",
        justifyItems: "start",
        ...shorthands.gap("5px"),
    },
    field30: {
        width: "30%",
        display: "grid",
        justifyItems: "start",
        ...shorthands.gap("5px"),
    },
    field40: {
        width: "40%",
        display: "grid",
        justifyItems: "start",
        ...shorthands.gap("5px"),
    },
    field50: {
        width: "50%",
        display: "grid",
        justifyItems: "start",
        ...shorthands.gap("5px"),
    },
    fluid: {
        width: "100%",
        minWidth: "50px",
    },
    fluidWithZeroBottomMargin: {
        width: "100%",
        minWidth: "50px",
        marginBottom: "0px",
    },
    label: {
        marginBottom: "5px",
        marginLeft: "20px",
    },
    label2: {
        marginBottom: "5px",
        marginRight: "20px",
    },
    onSingleLine: {
        display: "flex",
        flexDirection: "row",
        ...shorthands.gap("5px"),
        width: "100%",
        alignItems: "flex-start",
    },
    spaceBetween: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },
    spaceBetween2: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: "5px",
    },
    ColFullDragDrop: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        rowGap: "60px"
    },
    optionContainer: {
        maxHeight: "300px",
    },
    onSingleLinWithFilePreviewe: {
        display: "flex",
        flexDirection: "row",
        ...shorthands.gap("15px"),
        width: "100%",
        height: "100%",
        justifyContent: "space-between",
    },
    FilePreviewPart: {
        display: "flex",
        flexDirection: "column",
        Height: "100%",
        width: "100%",
        ...shorthands.overflow("hidden"),
    },
    FilePreviewPart2: {
        position: "relative",
        height: "100%",
        overflowX: "auto",
        overflowY: "visible",
    },
    FilePreviewPart3: {
        position: "absolute",
    },
    InfoPart: {
        display: "flex",
        maxHeight: "100%",
        width: "750px",
        maxWidth: "40%",
        overflowX: "hidden",
        overflowY: "auto",
    },
    DialogContentWithFilePreview: {
        display: "flex",
        maxWidth: "80%",
    },
    DialogContentConsultant: {
        display: "flex",
        maxWidth: "800px",
    },
    Horizontal: {
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline",
    },
    Vertical: {
        display: "flex",
        flexDirection: "column",
    },
    ContentBoxBrandBackground: {
        display: "flex",
        flexDirection: "column",
        background: tokens.colorBrandBackground2,
        borderRadius: tokens.borderRadiusLarge,
        padding: "8px"
    },
    ContentBoxBrandBackground2: {
        display: "flex",
        flexDirection: "column",
        background: tokens.colorBrandBackground2Pressed,
        borderRadius: tokens.borderRadiusLarge,
        padding: "8px"
    },
    ContentBoxBrandBackgroundGrid: {
        display: "grid",
        gridTemplateColumns: "max-content 1fr",
        columnGap: tokens.spacingHorizontalS,
        rowGap: tokens.spacingHorizontalXS,
        alignItems: "baseline"
    },
    ContentBoxBrandBackgroundGrid2: {
        display: "grid",
        gridTemplateColumns: "1fr max-content",
        columnGap: tokens.spacingHorizontalS,
        rowGap: tokens.spacingHorizontalXS,
        alignItems: "baseline"
    },
    ContentBoxBrandBackgroundGridInvoiceTotal: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        columnGap: tokens.spacingHorizontalS,
        rowGap: tokens.spacingHorizontalXS,
        alignItems: "baseline"
    },
    ContentBoxBrandBackgroundGrid2Item: {
        paddingTop: "4px",
        marginTop: "4px",
        borderTopWidth: "1px",
        borderTopStyle: "solid",
        borderTopColor: tokens.colorNeutralForeground2,
    },
    ContentBoxBrandBackgroundGrid2ItemNoLine: {
        paddingTop: "none",
        borderTop: "none",
    },
});

export const useTabStyles = makeStyles({
    // https://github.com/microsoft/fluentui/issues/31211
    provider: {
        height: "100%",
        width: "100%",
        display: "flex",
        background: "transparent",
        //colorScheme: tokens.colorScheme,
        //accentColor: tokens.colorBrandForeground1,
    },
    providerSignInTab: {
        height: "100%",
        width: "100%",
        display: "flex",
        background: "transparent",
        justifyContent: "center",
    },
    layoutRoot: {
        display: "grid",
        gridTemplateColumns: "67% 33%",
        //gridTemplateRows: "auto",
        gridAutoRows: "min-content auto",
        width: "100%",
        height: "100%",
    },
    layoutRootSpan2: {
        height: "calc(100%-20px)",
        display: "flex",
        flexDirection: "column",
        gridColumnStart: "1",
        gridColumnEnd: "span 2",
        ...shorthands.overflow("auto"),
        ...shorthands.padding("10px"),
        width: "100%",
    },
    layoutRootSpan1: {
        height: "calc(100%-20px)",
        width: "100%",
        display: "flex",
        ...shorthands.overflow("auto"),
        ...shorthands.padding("10px"),
    },
    layoutRootQV: {
        display: "flex",
        backgroundColor: tokens.colorBrandBackground2,
        ...shorthands.overflow("auto"),
        ...shorthands.padding("20px"),
        minWidth: "250px",
    },
    //layoutFull: {
    //    // Stack the label above the field with a gap
    //    display: "flex",
    //    flexDirection: "row",
    //    width: "100%",
    //    height: "100%",
    //    ...shorthands.overflow("auto"),
    //},
    //layoutWithQV: {
    //    // Stack the label above the field with a gap
    //    width: "67%",
    //    height: "100%",
    //    ...shorthands.overflow("auto"),
    //},
    //layoutWithQV_QV: {
    //    // Stack the label above the field with a gap
    //    width: "33%",
    //    height: "100%",
    //    backgroundColor: tokens.colorBrandBackground2,
    //    ...shorthands.overflow("auto"),
    //    ...shorthands.padding("20px"),
    //},
    //layoutWithQV_QVFull: {
    //    // Stack the label above the field with a gap
    //    width: "100%",
    //    height: "100%",
    //    backgroundColor: tokens.colorBrandBackground2,
    //    ...shorthands.overflow("auto"),
    //    ...shorthands.padding("10px"),
    //},
    rootSub: {
        // Stack the label above the field with a gap
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        //    overflowX: "hidden",
        //    overflowY: "scroll",
    },
    columnpaddind10: {
        display: "flex",
        flexDirection: "column",
        ...shorthands.padding("10px"),
    },
    flexrow: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "4px",
    },
    flexcolumn100: {
        // Stack the label above the field with a gap
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    flexrow100: {
        // Stack the label above the field with a gap
        display: "flex",
        flexDirection: "row",
        width: "100%",
    },
    marginBottom6px: {
        marginBottom: "6px",
    },
    overflowauto: {
        ...shorthands.overflow("auto"),
    },
    width100TopBottomMargin: {
        width: "100%",
        marginTop: "2px",
        marginBottom: "2px",
    },
    width100: {
        width: "100%",
    },
    width100CenterContainer: {
        display: "flex",
        width: "100%",
        justifyContent: "space-around",
    },
    width55: {
        width: "55%",
    },
    width35: {
        width: "35%",
    },
    width15: {
        width: "15%",
    },
    width17: {
        width: "17%",
    },
    LeftMargin: {
        marginLeft: "10px",
    },
    TestButton: {
        minWidth: "unset",
        justifyContent: "start",
        ...shorthands.padding("0px"),
        textAlign: "left",
    },
    List: {
        display: "flex",
        flexDirection: "column",
        ...shorthands.gap("5px"),
        marginTop: "5px",
        marginBottom: "5px",
    },
    width15andCenter: {
        width: "15%",
        justifyContent: "space-around",
    },
    centerInfo: {
        textAlign: "center",
    },
    noBorder: {
        borderBottomStyle: "unset",
    },
    MainBar: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        ...shorthands.gap("5px"),
    },
    VAlign: {
        display: "flex",
        alignItems: "center",
    },
    MarginLeftAuto: {
        display: "flex",
        flexDirection: "row",
        marginLeft: "auto",
        textWrap: "nowrap",
        ...shorthands.gap("5px"),
    },
    UnsetFlexGrow: {
        flexGrow: "unset",
    },
    AfterAvatarMargin: {
        marginRight: tokens.spacingHorizontalS,
    },
    DangerText: {
        color: tokens.colorStatusDangerForeground2,
        backgroundColor: tokens.colorStatusDangerBackground2,
        lineHeight: tokens.lineHeightBase600,
        fontWeight: tokens.fontWeightRegular,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalS,
        ...shorthands.borderColor(tokens.colorStatusDangerBorder2),
        ...shorthands.borderWidth(tokens.strokeWidthThick),
    },
    WarningText: {
        color: tokens.colorStatusWarningForeground2,
        backgroundColor: tokens.colorStatusWarningBackground2,
        lineHeight: tokens.lineHeightBase600,
        fontWeight: tokens.fontWeightRegular,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalS,
        ...shorthands.borderColor(tokens.colorStatusWarningBorder2),
        ...shorthands.borderWidth(tokens.strokeWidthThick),
    },
    WarningText2: {
        color: tokens.colorPaletteGrapeForeground2,
        backgroundColor: tokens.colorPaletteGrapeBackground2,
        lineHeight: tokens.lineHeightBase600,
        fontWeight: tokens.fontWeightRegular,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalS,
        ...shorthands.borderColor(tokens.colorPaletteGrapeBackground2),
        ...shorthands.borderWidth(tokens.strokeWidthThick),
    },
    SuccessText: {
        color: tokens.colorStatusSuccessForeground2,
        backgroundColor: tokens.colorStatusSuccessBackground2,
        lineHeight: tokens.lineHeightBase600,
        fontWeight: tokens.fontWeightRegular,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalS,
        ...shorthands.borderColor(tokens.colorStatusSuccessBorder2),
        ...shorthands.borderWidth(tokens.strokeWidthThick),
    },
    InlineCenteredDangerText: {
        color: tokens.colorStatusDangerForeground2,
        backgroundColor: tokens.colorStatusDangerBackground2,
        lineHeight: tokens.lineHeightBase400,
        fontWeight: tokens.fontWeightRegular,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalS,
        marginTop: tokens.spacingVerticalXXS,
        marginBottom: tokens.spacingVerticalXXS,
        ...shorthands.borderColor(tokens.colorStatusDangerBorder2),
        ...shorthands.borderWidth(tokens.strokeWidthThick),
        width: "fit-content",
        textAlign: "center",
        justifySelf: "center",
        alignSelf: "center",
    },
    InlineCenteredWarningText: {
        color: tokens.colorStatusWarningForeground2,
        backgroundColor: tokens.colorStatusWarningBackground2,
        lineHeight: tokens.lineHeightBase400,
        fontWeight: tokens.fontWeightRegular,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalS,
        marginTop: tokens.spacingVerticalXXS,
        marginBottom: tokens.spacingVerticalXXS,
        ...shorthands.borderColor(tokens.colorStatusWarningBorder2),
        ...shorthands.borderWidth(tokens.strokeWidthThick),
        width: "fit-content",
        textAlign: "center",
        justifySelf: "center",
        alignSelf: "center",
    },
    InlineCenteredWarningText2: {
        color: tokens.colorPaletteGrapeForeground2,
        backgroundColor: tokens.colorPaletteGrapeBackground2,
        lineHeight: tokens.lineHeightBase400,
        fontWeight: tokens.fontWeightRegular,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalS,
        marginTop: tokens.spacingVerticalXXS,
        marginBottom: tokens.spacingVerticalXXS,
        ...shorthands.borderColor(tokens.colorPaletteGrapeBackground2),
        ...shorthands.borderWidth(tokens.strokeWidthThick),
        width: "fit-content",
        textAlign: "center",
        justifySelf: "center",
        alignSelf: "center",
    },
    InlineCenteredSuccessText: {
        color: tokens.colorStatusSuccessForeground2,
        backgroundColor: tokens.colorStatusSuccessBackground2,
        lineHeight: tokens.lineHeightBase400,
        fontWeight: tokens.fontWeightRegular,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalS,
        marginTop: tokens.spacingVerticalXXS,
        marginBottom: tokens.spacingVerticalXXS,
        ...shorthands.borderColor(tokens.colorStatusSuccessBorder2),
        ...shorthands.borderWidth(tokens.strokeWidthThick),
        width: "fit-content",
        textAlign: "center",
        justifySelf: "center",
        alignSelf: "center",
    },
    segment: {
        backgroundColor: tokens.colorNeutralBackground1,
        width: "100%",
        marginBottom: tokens.spacingVerticalXXS,
        padding: "10px",
    },
    ProductGrid: {
        display: "grid",
        gridTemplateColumns: "60% 15%",
        width: "100%",
        alignItems: "center",
        paddingLeft: "20px",
    },
    SalesGrid: {
        display: "grid",
        gridTemplateColumns: "10% 15% 35% 8% 5% 17% 10%",
        width: "100%",
        alignItems: "center",
    },
    SalesGridInvoiced: {
        display: "grid",
        gridTemplateColumns: "10% 15% 35% 8% 5% 7% 10% 10%",
        width: "100%",
        alignItems: "center",
    },
    SalesGridTotal: {
        display: "grid",
        gridTemplateColumns: "52% 48%",
        width: "100%",
        alignItems: "center",
    },
    FlexCenterGap: {
        display: "flex",
        justifyContent: "center",
        alignItems: "baseline",
        gap: "10px"
    },
    ContactList: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "10px",
        marginBottom: tokens.spacingVerticalS,
    },
    ContactEditorEntry: {
        display: "grid",
        gridTemplateColumns: "45% 45% 10%",
        width: "100%",
    },
    ContactEditorEntryLine: {
        display: "flex",
        flexDirection: "column",
        ...shorthands.gap("5px"),
    },
});

export const useStackClassName = makeResetStyles({
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalL,
    marginTop: "5px",
    marginBottom: "5px",
    width: "100%",
});

// https://github.com/microsoft/fluentui/issues/31729

//export const EditIcon = bundleIcon(EditFilled, EditRegular, EditRegular);
//export const GroupIcon = bundleIcon(PeopleCommunity24Filled, PeopleCommunity24Regular, PeopleCommunity24Regular);
//export const ViewIcon = bundleIcon(Eye24Filled, Eye24Regular, Eye24Regular);
//export const UploadIcon = bundleIcon(ArrowUpload24Filled, ArrowUpload24Regular, ArrowUpload24Regular);
//export const DownloadIcon = bundleIcon(ArrowDownload24Filled, ArrowDownload24Regular, ArrowDownload24Regular);
//export const TrashCanIcon = bundleIcon(BinRecycle24Filled, BinRecycle24Regular, BinRecycle24Regular);
//export const FolderRefreshIcon = bundleIcon(FolderSync24Filled, FolderSync24Regular, FolderSync24Regular);
//export const FilterIcon = bundleIcon(Filter24Filled, Filter24Regular, Filter24Regular);
//export const AddIcon = bundleIcon(Add24Filled, Add24Regular, Add24Regular);
//export const ArrowClockwiseIcon = bundleIcon(ArrowClockwise24Filled, ArrowClockwise24Regular, ArrowClockwise24Regular);
//export const InfoIcon = bundleIcon(InfoFilled, InfoRegular, InfoRegular);
//export const BookStarIcon = bundleIcon(BookStarFilled, BookStarRegular, BookStarRegular);

export const EditIcon = bundleIcon(EditFilled, EditRegular);
export const GroupIcon = bundleIcon(PeopleCommunity24Filled, PeopleCommunity24Regular);
export const ViewIcon = bundleIcon(Eye24Filled, Eye24Regular);
export const UploadIcon = bundleIcon(ArrowUpload24Filled, ArrowUpload24Regular);
export const DownloadIcon = bundleIcon(ArrowDownload24Filled, ArrowDownload24Regular);
export const TrashCanIcon = bundleIcon(BinRecycle24Filled, BinRecycle24Regular);
export const DeleteIcon = bundleIcon(DeleteFilled, DeleteRegular);
export const FolderRefreshIcon = bundleIcon(FolderSync24Filled, FolderSync24Regular);
export const FilterIcon = bundleIcon(Filter24Filled, Filter24Regular);
export const AddIcon = bundleIcon(Add24Filled, Add24Regular);
export const ArrowClockwiseIcon = bundleIcon(ArrowClockwise24Filled, ArrowClockwise24Regular);
export const InfoIcon = bundleIcon(InfoFilled, InfoRegular);
export const BookStarIcon = bundleIcon(BookStarFilled, BookStarRegular);
export const DocumentOnePageAddIcon = bundleIcon(DocumentOnePageAddFilled, DocumentOnePageAddRegular);
export const MailArrowForwardIcon = bundleIcon(MailArrowForwardFilled, MailArrowForwardRegular);
export const CalendarPersonIcon = bundleIcon(CalendarPersonFilled, CalendarPersonRegular);
export const PlugConnectedSettingsIcon = bundleIcon(PlugConnectedSettingsFilled, PlugConnectedSettingsRegular);
export const TextGrammarSettingsIcon = bundleIcon(TextGrammarSettingsFilled, TextGrammarSettingsRegular);
export const DocumentPdfIcon = bundleIcon(DocumentPdfFilled, DocumentPdfRegular);
export const TaskListLtrIcon = bundleIcon(TaskListLtrFilled, TaskListLtrRegular);
export const CodeBlockEditIcon = bundleIcon(CodeBlockEditFilled, CodeBlockEditRegular);
export const CodeBlockIcon = bundleIcon(CodeBlockFilled, CodeBlockRegular);
export const GlobeArrowForwardIcon = bundleIcon(GlobeArrowForwardFilled, GlobeArrowForwardRegular);
export const GlobeAddIcon = bundleIcon(GlobeAddFilled, GlobeAddRegular);
export const GlobeDesktopIcon = bundleIcon(GlobeDesktopFilled, GlobeDesktopRegular);
export const GlobeShieldIcon = bundleIcon(GlobeShieldFilled, GlobeShieldRegular);
export const GlobeClockIcon = bundleIcon(GlobeClockFilled, GlobeClockRegular);
export const Board20Icon = bundleIcon(Board20Filled, Board20Regular);
export const Timeline20Icon = bundleIcon(Timeline20Filled, Timeline20Regular);
export const BoxArrowUp20Icon = bundleIcon(BoxArrowUp20Filled, BoxArrowUp20Regular);
export const BoxArrowLeft20Icon = bundleIcon(BoxArrowLeft20Filled, BoxArrowLeft20Regular);
export const Box20Icon = bundleIcon(Box20Filled, Box20Regular);
export const BoxCheckmark20Icon = bundleIcon(BoxCheckmark20Filled, BoxCheckmark20Regular);
export const ContactCardRibbon20Icon = bundleIcon(ContactCardRibbon20Filled, ContactCardRibbon20Regular);
export const CardUi20Icon = bundleIcon(CardUi20Filled, CardUi20Regular);
export const ContactCard20Icon = bundleIcon(ContactCard20Filled, ContactCard20Regular);
export const TaskListSquareDatabase20Icon = bundleIcon(TaskListSquareDatabase20Filled, TaskListSquareDatabase20Regular);
export const TaskListSquarePerson20Icon = bundleIcon(TaskListSquarePerson20Filled, TaskListSquarePerson20Regular);
export const BoxSearch20Icon = bundleIcon(BoxSearch20Filled, BoxSearch20Regular);
export const DocumentDatabase20Icon = bundleIcon(DocumentDatabase20Filled, DocumentDatabase20Regular);
export const AppsListDetail20Icon = bundleIcon(AppsListDetail20Filled, AppsListDetail20Regular);
export const GlobeShield20Icon = bundleIcon(GlobeShield20Filled, GlobeShield20Regular);
export const Info20Icon = bundleIcon(Info20Filled, Info20Regular);
export const DocumentFolder20Icon = bundleIcon(DocumentFolder20Filled, DocumentFolder20Regular);
export const PeopleTeam20Icon = bundleIcon(PeopleTeam20Filled, PeopleTeam20Regular);
//export const BuildingBank20Icon = bundleIcon(BuildingBank20Filled, BuildingBank20Regular);
export const ShiftsTeam20Icon = bundleIcon(ShiftsTeam20Filled, ShiftsTeam20Regular);
export const MoneyCalculator20Icon = bundleIcon(MoneyCalculator20Filled, MoneyCalculator20Regular);
export const CopySelectIcon = bundleIcon(CopySelectFilled, CopySelectRegular);
